module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('Row', {
    staticClass: "expand-row"
  }, _vm._l((_vm.itemList), function(item) {
    return _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Tooltip', {
      attrs: {
        "content": item.descr
      }
    }, [_c('a', {
      staticClass: "expand-value",
      on: {
        "click": function($event) {
          return _vm.editItem(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])], 1)
  }), 1)], 1), _vm._v(" "), _c('EditItemModal', {
    attrs: {
      "itemId": _vm.itemId,
      "value": _vm.editModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e4d92f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminConfigExpand.vue
// module id = 1874
// module chunks = 8